import { Box, Container, Divider, Flex, Grid, GridItem, Heading, Image, Text } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "scenes/layouts";
import LoadingScreen from "components/loading-screen";
import PartnerService from "services/partners/partner-service";
import { EmailIcon } from "@chakra-ui/icons";
import { FaWhatsapp } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";
import moment from "moment";
import PartnerStatistic from "./partner-statistic";
import PartnerHistory from "./partner-history";
import PartnerSales from "./partner-sales";

const PartnerProfileScene = (): ReactElement => {
    const { partnerId } = useParams();
    const [partner, setPartner] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);
        PartnerService.Get(partnerId).then((res: any) => {
            setPartner(res.result);
        }).finally(() => {
            setIsLoading(false);
        });
    }, [partnerId]);

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Mitra {partner.user.fullName}</Heading>
                </Box>
                <Box mt={6}>
                    <Box rounded={'lg'} boxShadow={'md'} p={8}>
                        <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(5, 1fr)' }} gap={4}>
                            <GridItem>
                                <Box boxSize={"200px"}>
                                    <Image rounded={'lg'} src={partner.user.profilePictureFullUrl || 'https://res.cloudinary.com/ruang-trader/image/upload/v1652634569/logosvillage/default-iser_nvxogs.webp'} />
                                </Box>
                            </GridItem>
                            <GridItem colSpan={4}>
                                <Box>
                                    <Heading fontSize={'2xl'} fontWeight={'extrabold'}>{partner.user.fullName}</Heading>
                                    <Flex alignItems={'center'} mt={2}>
                                        <EmailIcon />
                                        <Text ml={2} fontSize={'sm'} color={'gray.500'}>{partner.user.emailAddress}</Text>
                                    </Flex>
                                    <Flex alignItems={'center'} mt={2}>
                                        <FaWhatsapp />
                                        <Text ml={2} fontSize={'sm'} color={'gray.500'}>{partner.user.phoneNumber}</Text>
                                    </Flex>

                                    <Flex alignItems={'center'} fontSize={'sm'} mt={2}>
                                        <FiMapPin />
                                        <Text ml={2}>{partner.user.city ? `${partner.user.city}, ${partner.user.country}` : '-'}</Text>
                                    </Flex>

                                    <Text fontSize={'sm'} mt={1} fontWeight={'bold'}>{partner.user.dateOfBirth ? moment(partner.user.dateOfBirth).format("DD MMMM yyyy") : '-'}</Text>
                                </Box>
                            </GridItem>
                        </Grid>
                    </Box>
                </Box>
                <Box mt={6}>
                    <PartnerStatistic partnerSummary={partner} />
                </Box>
                <Box mt={6}>
                    <PartnerHistory partner={partner} />
                </Box>
                <Box mt={6}>
                    <PartnerSales partner={partner} />
                </Box>
            </Container>
        </Layout>
    );
};

export default PartnerProfileScene;